<ng-container *ngIf="form">

  <!-- Root node -->
  <div class="tree-root-label"
       [class.tree-node-selected]="isSelected(form)"
       (click)="selectNode(form, rootLabel)">
    <mat-icon class="tree-root-icon">description</mat-icon>
    <span>{{ rootLabel }}</span>
    <span *ngIf="form.fields?.length" class="tree-field-count">
      {{ form.fields!.length }} Felder
    </span>
  </div>

  <!-- Recursive subtree starting at root -->
  <ng-container *ngTemplateOutlet="levelTree; context:{ level: form, depth: 0 }">
  </ng-container>

  <!-- Legend -->
  <p class="tree-legend">
    <mat-icon class="tree-legend-icon">touch_app</mat-icon>
    Ebene anklicken um sie in der Vorschau anzuzeigen
  </p>

</ng-container>

<!-- ── Recursive level-tree template ──────────────────────────────────────── -->
<!--
  Context:
    level  – RendererForm | RendererLevel
    depth  – nesting depth (0 = direct children of root)
-->
<ng-template #levelTree let-level="level" let-depth="depth">
  <!--
    At depth > 0 the wrapper draws ONE continuous border-left that spans
    BOTH the field rows AND all child-level headers — no gaps.
    At depth 0 (root) there is no wrapper border.
  -->
  <div class="tree-level" [class.tree-level--nested]="depth > 0">

    <!-- Fields of this level -->
    <div class="tree-fields" *ngIf="level?.fields?.length">
      <div *ngFor="let field of level.fields"
           class="tree-field"
           [class.tree-field-hidden]="field.hidden">
        <mat-icon class="tree-field-icon">{{ fieldIcon(field.type) }}</mat-icon>
        <span class="tree-field-label">{{ field.label || 'Unbenanntes Feld' }}</span>
        <span class="tree-field-type">{{ fieldTypeLabel(field.type) }}</span>
      </div>
    </div>

    <!-- No fields, no children -->
    <div *ngIf="!level?.fields?.length && !level?.children?.length" class="tree-empty">
      Keine Felder
    </div>

    <!-- Child levels (recursive) -->
    <ng-container *ngFor="let child of level?.children">
      <div class="tree-child-level">

        <div class="tree-child-header"
             [class.tree-node-selected]="isSelected(child)"
             (click)="selectNode(child, child.name ?? 'Ebene')">
          <mat-icon class="tree-child-icon">folder_open</mat-icon>
          <span class="tree-child-name">{{ child.name }}</span>
          <span *ngIf="child.description" class="tree-child-desc">– {{ child.description }}</span>
          <span *ngIf="child.fields?.length" class="tree-field-count">
            {{ child.fields!.length }} Felder
          </span>
        </div>

        <ng-container *ngTemplateOutlet="levelTree; context:{ level: child, depth: depth + 1 }">
        </ng-container>

      </div>
    </ng-container>

  </div>
</ng-template>
